import React, { useMemo } from "react"
import { Container } from "reactstrap"
import TableContainer from "components/Common/TableContainer"
import { getTableSortingHeaderIcon } from "helpers/common"
import { usePermission } from "hooks/usePermission"

const SigningRequestsSearchResults = ({ data = [] }) => {
  const { hasPermission } = usePermission()

  const columns = useMemo(() => {
    const data = [
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Date"),
        accessorKey: "formatted_created_at",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Request ID"),
        accessorKey: "unique_code",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="code-number">
            {row?.original.template_type === "TERM_SHEET"
              ? row?.original.icdsRequests?.icds?.unique_code
              : row?.original?.agreement_ref}
          </div>
        ),
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Document Type"),
        accessorKey: "template_type",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="code-status">
            {row?.original.template_type === "TERM_SHEET" ? (
              <div className="badge approved">
                <span></span> ICD Schedule Terms
              </div>
            ) : (
              <div className="badge counteroffer">
                <span></span> ICD Master Agreement
              </div>
            )}
          </div>
        ),
      },

      {
        id: "actions",
        header: "Actions",
        cell: ({ row }) => (
          <div className="d-flex flex-column align-items-center gap-1 buttons">
            <a
              href={row.original.doc}
              target="_blank"
              rel="noopener noreferrer"
            >
              Sign Now
            </a>
          </div>
        ),
      },
    ]

    return data
  }, [hasPermission])

  return (
    <React.Fragment>
      <Container fluid>
        <TableContainer
          count={data.length}
          filters={{ page: 1, pageSize: 100 }}
          columns={columns}
          data={data}
          isGlobalFilter={false}
          isCustomPageSize={false}
          isPagination={false}
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </Container>
    </React.Fragment>
  )
}

export default SigningRequestsSearchResults
